import { CompanyStatsResult } from 'types/generated.types';
import CompanyHeader from '../vara-haften/CompanyHeader'
import CompanyModalCoupon from '../vara-haften/CompanyModalCoupon'

const { REACT_APP_IMAGE_BASE_URL } = process.env;

const CompanyStatsCoupons = ({ companyStatsData, companyTypesData }) => {

  const companyStats: CompanyStatsResult = companyStatsData.companyStatsByToken;
  const booklet = companyStats.booklet;
  const validTo = new Date(booklet?.validTo).toLocaleDateString('sv-SE', { day: 'numeric', month: 'numeric' }) || '';

  if (!companyStats) {
    return <div>Laddar...</div>
  }

  const couponsWithUsage = companyStats.coupons
    .filter(c => c !== null)
    .sort((a, b) => (a.position ?? Infinity) - (b.position ?? Infinity))
    .map(coupon => {
      const usage = companyStats.couponUsages.find(u => u.couponId === coupon._id);
      return {
        ...coupon,
        amount: usage?.amount ?? 0,
      };
    });

  return (
    <div className="company-review-booklet box flex flex-col items-center">
      {booklet &&
        <div className="company-review-booklet-header relative flex flex-col items-center">
          <div className='booklet-bg left' style={{ backgroundColor: booklet.colorLeft || '' }} />
          <div className='booklet-bg right' style={{ backgroundColor: booklet.colorRight || '' }} />
          <img src={(REACT_APP_IMAGE_BASE_URL + (booklet?.logoURL || '')) || ''} alt={booklet?.title || ''} />
          <h3 style={{ color: booklet?.colorFont || '#fff' }}>{booklet?.title}</h3>
          <small style={{ color: booklet?.colorFont || '#fff' }}>Giltigt t.o.m {validTo}</small>
        </div>
      }
      <div className="relative company-review-coupons box">
        <CompanyHeader
          company={companyStats.company}
          companyType={companyTypesData?.types[companyStats.company.typeId]}
        />
        {couponsWithUsage.map(coupon =>
          <CompanyModalCoupon
            key={coupon!._id}
            userOwnsBooklet={false}
            coupon={coupon}
            booklet={booklet}
            isReview={false}
          />
        )}
      </div>
    </div>
  )
}

export default CompanyStatsCoupons
